export default function (dateString) {
  const parts = dateString.split(' ')
  const [datePart, timePart] = parts

  const dateComponents = datePart.split('-')
  const timeComponents = timePart.split(':')

  const isoString = `${dateComponents[0]}-${dateComponents[1]}-${dateComponents[2]}T${timeComponents[0]}:${timeComponents[1]}:${timeComponents[2]}Z`

  return isoString
}
